import React from "react";

export const FaAngleUp = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M9.16666 4.51171L4.75582 8.92255C4.43082 9.24755 3.90249 9.24755 3.57749 8.92255C3.25249 8.59755 3.25249 8.06921 3.57749 7.74421L9.41082 1.91088C9.73582 1.58505 10.2642 1.58505 10.5892 1.91088L16.4225 7.74421C16.7475 8.06921 16.7475 8.59755 16.4225 8.92255C16.0975 9.24755 15.5692 9.24755 15.2442 8.92255L10.8333 4.51171V17.5C10.8333 17.96 10.46 18.3334 9.99999 18.3334C9.53999 18.3334 9.16666 17.96 9.16666 17.5V4.51171Z" fill="black" />
    </svg>
);

export const X = () => (
    <svg width="20" height="20" viewBox="0 0 487 487" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_6416_126)">
            <path d="M474.188 394.832L92.7864 13.4306C76.1524 -3.20342 49.1846 -3.20342 32.5766 13.4306L12.4755 33.5005C-4.15849 50.1397 -4.15849 77.1075 12.4755 93.7155L393.877 475.117C410.516 491.751 437.484 491.751 454.092 475.117L474.162 455.047C490.827 438.439 490.827 411.466 474.188 394.832Z" fill="#F44336" />
            <path d="M393.877 13.4306L12.4755 394.832C-4.15849 411.466 -4.15849 438.439 12.4755 455.047L32.5454 475.117C49.1846 491.751 76.1524 491.751 92.7604 475.117L474.188 93.7415C490.827 77.1075 490.827 50.1397 474.188 33.5317L454.118 13.4618C437.484 -3.20341 410.516 -3.20341 393.877 13.4306Z" fill="#F44336" />
        </g>
        <defs>
            <clipPath id="clip0_6416_126">
                <rect width="486.667" height="486.667" fill="white" />
            </clipPath>
        </defs>
    </svg>
);